/* eslint-disable @typescript-eslint/no-restricted-types */
import { camelCase, isArray, isPlainObject, isString, snakeCase } from 'lodash';
import dot from 'dot-object';

const convertKeysToSnakeCase = <T>(obj: T): T => {
  if (isArray(obj)) {
    return (obj as unknown[]).map((v) => convertKeysToSnakeCase(v)) as T;
  }
  if (isPlainObject(obj)) {
    return Object.keys(obj as Record<string, unknown>).reduce(
      (result, key) => ({
        ...result,
        [`${key.startsWith('_') ? '_' : ''}${snakeCase(key)}`]: convertKeysToSnakeCase(
          (obj as Record<string, unknown>)[key],
        ),
      }),
      {},
    ) as T;
  }
  return obj;
};

const convertKeysToCamelCase = <T>(obj: T): T => {
  if (isString(obj)) {
    return obj;
  }
  if (isArray(obj)) {
    return (obj as unknown[]).map((v) => convertKeysToCamelCase(v)) as T;
  }
  if (isPlainObject(obj)) {
    const convertedObject = dot.object(obj as Record<string, unknown>);
    return Object.keys(convertedObject).reduce(
      (result, key) => ({
        ...result,
        [camelCase(key)]: convertKeysToCamelCase((obj as Record<string, unknown>)[key]),
      }),
      {},
    ) as T;
  }
  return obj;
};

const transformRemoved = <T extends object>(containers: T[]): (T & { _destroy: boolean })[] =>
  containers?.map((container) => ({
    ...container,
    _destroy: true,
  }));

const transformPosition = <T extends object>(containers: T[]): (T & { position: number })[] =>
  containers?.map((container, index) => ({
    ...container,
    position: index,
  }));

export { convertKeysToSnakeCase, convertKeysToCamelCase, transformRemoved, transformPosition };
